'use strict';

import React from 'react';
import flux from 'utils/flux';
import AltContainer from 'alt-container';
import QuotaWarning from 'components/quota/quotaWarning';
import FooterBar from 'components/footerBar/footerBar';
import BasketTitle from './basketTitle';
import BasketListingItem from './basketListingItem';
import BasketEmpty from 'components/basket/basketEmpty';
import BasketSidebar from 'components/basket/basketSidebar';
import LoadingSpinner from 'components/spinner/spinner';
import BasketHeaderBar from 'components/headerBar/headerBasket';

var BasketPage = React.createClass({
    displayName: 'BasketPage',
    mixins: [],
    propTypes: {},
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    statics: {
        willTransitionTo: function( transition, param, query, callback ) {
            if ( !flux.getStore('app').isAuthenticated() ) {
                return transition.redirect( '/login', {}, { nextPath: transition.path } );
            }
            if ( !flux.getStore('app').hasAcceptedLatestTerms() ) {
                return transition.redirect( '/accept_terms', {}, {nextPath: transition.path} );
            }
            flux.getActions('modals').activateLoading();
            return BasketPage.getBasketData(param).then(() => {
                flux.getActions('modals').disableLoading();
                callback();
            }).catch(e => {
                flux.getActions('basket').activateLast();
            });
        },

        getBasketData: async function(param) {
            const basketStore = flux.getStore('basket');
            await basketStore.loadBaskets();
            if (param.id) {
                await basketStore.loadBasket( param.id );
            }
        }
    },
    render() {
        const currentBasketId = this.props.params.id;
        const router = this.context.router;
        const basketStore = flux.getStore('basket');
        const mediaStore = flux.getStore('media');
        const modalStore = flux.getStore('modals');

        return (
            <AltContainer
                stores={{ basketStore, mediaStore, modalStore }}
                render={(props) => {
                    const currentBasket = props.basketStore.basket;
                    const { loading } = modalStore.getState();

                    if (!( basketStore.isLoading() || loading )) {
                        // Coming from the 'basket' page
                        if ( !currentBasketId && currentBasket.size > 0 ) {
                            router.transitionTo( 'singleBasket', { id: currentBasket.get('id') });
                        }

                        // No Baskets
                        if ( !currentBasket || currentBasket.size === 0 ) {
                            return <BasketEmpty />;
                        }

                        // Basket Not Found
                        if ( !currentBasket || currentBasket.size === 0 ) {
                            router.transitionTo('landing-page');
                            return (<div />);
                        }
                    }
                    return (
                        <div className="page baskets">
                            <div className="headerbar">
                                <div className="container--centered">
                                    <BasketHeaderBar basket={currentBasket} baskets={props.basketStore.baskets}/>
                                </div>
                            </div>

                            <div className="basket__container container--centered">
                                <div className="container__filters">
                                    <BasketSidebar name="singleBasket" baskets={props.basketStore.baskets}/>
                                </div>
                                <div className="container__content">
                                {( basketStore.isLoading() || loading ) ?
                                    <LoadingSpinner />
                                    :
                                    <div>
                                    <QuotaWarning />
                                    <BasketTitle name={currentBasket.get('name')} basketId={currentBasket.get('id')} />
                                    {currentBasket.get('items').map((item, ix) => {
                                        return (
                                            <BasketListingItem key={'basket_li_'+ix} item={item} />
                                        );
                                    })}
                                    {currentBasket.get('items').size === 0 ? <p>{flux.t('no_basket_selected')}</p> : ''}
                                    </div>
                                }
                                </div>
                            </div>
                        </div>
                    );
                }}>
            </AltContainer>
        );
    }
});

module.exports = BasketPage;



// WEBPACK FOOTER //
// ./app/pages/basket/index.jsx